<template>
  <base-page v-bind="payload" :error="error">
    <template slot="stack-trace">
      {{ payload.error.stack }}
    </template>
  </base-page>
</template>

<script>
  import BasePage from './_base';

  export default {
    components: { BasePage },
    data() {
      return {
        error: {
          code: '520'
        }
      }
    },
    props: {
      payload: {
        type: Object,
        default: () => ({})
      }
    }
  };
</script>
